import React from 'react';
import { Helmet } from 'react-helmet';
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  UncontrolledDropdown,
  Breadcrumb,
  BreadcrumbItem,
  TabContent,
  TabPane
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as actions from '@src/store/actions';
import { Link } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import PolicyCarrierModal from '../PolicyCarrierModal/PolicyCarrierModal';
import classnames from 'classnames';
import Activities from '@components/Elements/Activites/Activities';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import Auth from '@src/components/Elements/Auth/Auth';

class PolicyCarrierView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalActive: false,
      activeTab: '1'
    };

    if (
      props.entity.id === undefined ||
      props.entity.id !== parseInt(props.id, 10)
    ) {
      props.getEntity(props.id);
    }
  }

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render = () => {
    console.log(this.props.entity);
    const { entity } = this.props;
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | Policy Carrier</title>
        </Helmet>
        {entity.id !== undefined &&
          this.props.entity.id === parseInt(this.props.id, 10) && (
            <React.Fragment>
              {this.props.loading && (
                <ProgressBox
                  text={'Loading ...'}
                  loader={'transparent-background'}
                />
              )}
              <div>
                <Breadcrumb className={'pt-0'} listClassName={'pt-0 pl-0'}>
                  <BreadcrumbItem>
                    <Link to={'/carriers'}>Policy Carriers</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active>{entity.name}</BreadcrumbItem>
                </Breadcrumb>
              </div>
              <Row>
                <Col>
                  <div className={'float-left mr-3'}>
                    <FontAwesomeIcon
                      icon={['fas', 'home']}
                      className={'fa-3x color-blue'}
                    />
                  </div>
                  <div className={'color-blue font-md float-left text-break'}>
                    {entity.name}
                    <div className={'color-blue font-sm'}>Policy Carrier</div>
                  </div>
                  <Auth action={'Carriers::edit'}>
                    <div className={'float-right'}>
                      <UncontrolledDropdown>
                        <DropdownToggle caret>Actions</DropdownToggle>
                        <DropdownMenu right>
                          <DropdownItem
                            onClick={() => this.toggle('modalActive')}
                          >
                            Edit Details
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </Auth>
                </Col>
              </Row>
              <Row className={'mt-3'}>
                <Col>
                  <Card>
                    <CardBody>
                      <Row className={'pb-5'}>
                        <Col>
                          <Nav tabs>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: this.state.activeTab === '1',
                                  pointer: true
                                })}
                                onClick={() => {
                                  this.toggleTab('1');
                                }}
                              >
                                Details
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: this.state.activeTab === '2',
                                  pointer: true
                                })}
                                onClick={() => {
                                  this.toggleTab('2');
                                }}
                              >
                                History
                              </NavLink>
                            </NavItem>
                          </Nav>
                          <TabContent
                            activeTab={this.state.activeTab}
                            className={
                              'p-3 border-left border-right border-bottom'
                            }
                          >
                            <TabPane tabId="1">
                              <Row>
                                <Col className={'pb-2'}>
                                  <strong>NAIC #</strong>&nbsp;&nbsp;&nbsp;
                                  {this.props.entity.naic_number}
                                </Col>
                              </Row>
                              <Row>
                                {Object.keys(this.props.policyTypes).map(
                                  index => {
                                    return (
                                      <Col xs={6} key={index}>
                                        <label>
                                          <input
                                            type={'checkbox'}
                                            checked={
                                              this.props.entity.policy_types.indexOf(
                                                parseInt(index, 10)
                                              ) !== -1
                                            }
                                          />{' '}
                                          {this.props.policyTypes[index]}
                                        </label>
                                      </Col>
                                    );
                                  }
                                )}
                              </Row>
                            </TabPane>

                            <TabPane tabId="2">
                              <Activities
                                activities={this.props.entity.activities}
                              />
                            </TabPane>
                          </TabContent>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <PolicyCarrierModal
                entity={this.props.entity}
                history={this.props.history}
                isActive={this.state.modalActive}
                toggle={() => this.toggle('modalActive')}
              />
            </React.Fragment>
          )}
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    entity: state.policyCarrier.viewItem,
    loading: state.policyCarrier.loading,
    policyTypes: state.auth.policy_types
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getEntity: entityId => dispatch(actions.getPolicyCarrier(entityId))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PolicyCarrierView);
